<template>
  <div class="page">
    <van-sticky>
      <van-cell :value="selectedDateInterval" @click="showDateSelector = true" is-link icon="calendar-o" />
      <div class="separate"></div>
    </van-sticky>

    <van-list v-model:loading="loading" :finished="finished" @load="loadPage">
      <van-cell v-for="item in list" :key="item.id" :title="item.type" :value="item.transactionNo"
        :label="item.createTime" is-link center @click="showRecord(item.id)">
        <template #title>
          <span style="margin-right:10px;">{{ item.type }}</span>
          <van-tag :type="toTagType(item.state)">{{ toStateLabel(item.state) }}</van-tag>
        </template>
      </van-cell>
      <van-empty v-if="list.length === 0" description="暂无记录" />
    </van-list>

    <van-calendar v-model:show="showDateSelector" type="range" color="#1989fa" :max-range="30" allow-same-day
      :default-date="[startDate, endDate]" :min-date="new Date(2021, 5, 1)" :max-date="new Date()"
      confirm-disabled-text="请选择结束时间" @confirm="onConfirm" />
  </div>
</template>

<script>
import ds from "@/utils/dateformat";
import { Cell, Calendar, List, Sticky, Row, Col, Empty, Tag } from "vant";
import additionalApi from "@/api/additional";

const stateLabels = {
  0: "待验证",
  1: "加款成功",
  2: "加款失败",
  3: "已撤销",
};

const tagTypes = {
  0: "primary",
  1: "success",
  2: "danger",
  3: "warning"
}

export default {
  name: "Additional",

  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Sticky.name]: Sticky,
    [Row.name]: Row,
    [Col.name]: Col,
    [Empty.name]: Empty,
    [Calendar.name]: Calendar,
    [Tag.name]: Tag
  },

  data() {
    return {
      userId: "",
      list: [],
      loading: false,
      finished: false,
      page: 0,
      size: 20,
      showDateSelector: false,
      startDate: null,
      endDate: null,
    };
  },

  created() {
    let now = new Date();
    this.startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    this.endDate = new Date();
  },

  mounted() {
    this.userId = this.$store.state.user.user.id;
  },

  computed: {
    selectedDateInterval() {
      return (
        ds.dateFormat(this.startDate, "yyyy/MM/dd") +
        " ~ " +
        ds.dateFormat(this.endDate, "yyyy/MM/dd")
      );
    },
  },

  methods: {
    toStateLabel: function (val) {
      return stateLabels[val];
    },
    toTagType: function (val) {
      return tagTypes[val];
    },
    onConfirm: function (values) {
      const [start, end] = values;
      this.showDateSelector = false;
      this.startDate = start;
      this.endDate = end;
      this.list = [];
      this.reloadPage();
    },
    loadPage: function () {
      additionalApi
        .page(++this.page, this.size, {
          userId: this.userId,
          startDate: ds.dateFormat(this.startDate, "yyyy/MM/dd"),
          endDate: ds.dateFormat(this.endDate, "yyyy/MM/dd"),
        })
        .then((res) => {
          if (res.success) {
            this.list = this.list.concat(res.data.records);
          }
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.list.length >= res.data.total) {
            this.finished = true;
          }
        });
    },
    reloadPage() {
      this.list = [];
      this.page = 0;
      this.size = 20;
      this.loading = false,
        this.finished = false,
        this.loadPage();
    },
    showRecord(val) {
      this.$router.push({ name: "AdditionalRecord", params: { id: val } });
    }
  },
};
</script>

<style scoped>
.page {
  /* padding: 0px 10px; */
}

.separate {
  height: 10px;
  background-color: rgb(236, 232, 232);
}
</style>
